import { css } from 'styled-components'

export const fadeInStyles = css`
  animation: fade-in ease-out 200ms;

  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`
